<template>
  <div class="custom-makercart-section">
    <SearchAndFiltersSection
      :search-query="searchQuery"
      :selected-sort="selectedSort"
      :active-locale="activeLocale"
      :selected-chips="selectedChips"
      search-placeholder="Search activities by grade, subject, or keyword"
      @update:search-query="$emit('update:searchQuery', $event)"
      @update:selected-sort="$emit('update:selectedSort', $event)"
      @search="handleSearch"
      @clear-search="clearSearch"
      @locale-changed="localeChanged"
      @cart-clicked="cartClicked"
      @clear-filter="clearFilter"
      @clear-all-filters="clearAllFilters"
      @sort-changed="sortChanged"
    />

    <ItemsGridSection
      :items="items"
      :is-loading="isLoading"
      :error="error"
      :error-code="errorCode"
      :is-user-logged="isUserLogged"
      :empty-state-title="emptyStateTitle"
      :not-found-message="notFoundMessage"
      :current-page="currentPage"
      :total-pages="totalPages"
      :visible-pages="visiblePages"
      @update-liked-status="updateLikedStatus"
      @item-clicked="handleItemClicked"
      @page-changed="changePage"
    />
  </div>
</template>

<script setup>
/* eslint-disable */
import SearchAndFiltersSection from "./SearchAndFiltersSection.vue";
import ItemsGridSection from "./ItemsGridSection.vue";

defineProps({
  searchQuery: {
    type: String,
    default: "",
  },
  selectedSort: {
    type: String,
    default: "top-activities",
  },
  activeLocale: {
    type: String,
    default: "US",
  },
  selectedChips: {
    type: Array,
    default: () => [],
  },
  items: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: null,
  },
  errorCode: {
    type: String,
    default: null,
  },
  isUserLogged: {
    type: Boolean,
    default: false,
  },
  emptyStateTitle: {
    type: String,
    default: "No makercart activities available",
  },
  notFoundMessage: {
    type: String,
    default:
      "No makercart activities are currently available. Please check back later.",
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
  visiblePages: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  "update:searchQuery",
  "update:selectedSort",
  "search",
  "clear-search",
  "locale-changed",
  "cart-clicked",
  "clear-filter",
  "clear-all-filters",
  "sort-changed",
  "update-liked-status",
  "item-clicked",
  "page-changed",
]);

const handleSearch = () => {
  emit("search");
};

const clearSearch = () => {
  emit("update:searchQuery", "");
  emit("clear-search");
};

const localeChanged = (locale) => {
  emit("locale-changed", locale);
};

const cartClicked = () => {
  emit("cart-clicked");
};

const clearFilter = (filterKey) => {
  emit("clear-filter", filterKey);
};

const clearAllFilters = () => {
  emit("clear-all-filters");
};

const sortChanged = (sortParam) => {
  emit("sort-changed", sortParam);
};

const updateLikedStatus = (data) => {
  emit("update-liked-status", data);
};

const handleItemClicked = (makercartId) => {
  emit("item-clicked", makercartId);
};

const changePage = (page) => {
  emit("page-changed", page);
};
</script>

<style scoped>
.custom-makercart-section {
  width: 100%;
}
</style>
